<template lang="pug">
  .compatibility-container(v-if="result && !hidden")
    Message.compatibility(status="warning" v-if="result?.incompatible?.length && !result?.compatible?.length")
      .msg-body
        | {{__('This product is NOT compatible with the {item} in your {source}.', { item: result.incompatible?.[0].name, source: result.incompatible?.[0].src|| 'cart' })}}
        .links
          button.lnk.a11y(@click="showModal = true" ) {{ __('View compatible products') }}
          button.lnk.a11y(@click="dismiss") {{ __('Dismiss') }}
    compatibility-modal(
      v-if="showModal"
      :buy-request="buyRequest"
      :compatResult="result"
      @close="showModal = false"
      mode="info"
    )
</template>
<script lang="ts" setup>
import { ref, watch, computed, onMounted } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import { checkCompatibility, type CompatibilityResult } from '@/js/helpers/compatibility'
import CompatibilityModal from '@/js/components/compatibility/compatibility-modal.vue'
import { useListStore } from '@/js/stores/listStore'
import { useProductStore } from '@/js/stores/productStore'
import { getSimpleForBuyRequest, listProductIds } from '@/js/helpers/buy-request'
import { useCustomerStore } from '@/js/stores/customerStore'
import type { BuyRequest } from '@/js/services/types/order'

const props = defineProps<{ buyRequest: BuyRequest }>()
const customerStore = useCustomerStore()
const listStore = useListStore()
const productStore = useProductStore()

const rogue = useRogue()

const hidden = ref(false)
const showModal = ref(false)
const result = ref<CompatibilityResult | null>(null)

const simple = computed(() => getSimpleForBuyRequest(props.buyRequest, rogue))

const cartItems = computed(() => listStore.cart.items)

const cartProducts = computed<string>(() => listProductIds(cartItems.value).join(','))

function dismiss() {
  rogue.track.track({
    type               : 'compatibility',
    event              : 'Dismissed compatibility warning',
    incompatibleSku    : result.value?.incompatible[0].sku,
    selectedBuyRequest : props.buyRequest || undefined,
  })
  hidden.value = true
}

async function reset() {
  hidden.value = false
  showModal.value = false
  if (rogue.ssr) {
    return
  }

  await listStore.init(rogue)
  await customerStore.loadOrders(rogue)

  const needsLoaded = listProductIds(cartItems.value)
    .filter(productId => !productStore.products[productId])

  await productStore.loadAll(needsLoaded, rogue)

  result.value = checkCompatibility(rogue, props.buyRequest)
}

onMounted(reset)

watch(() => simple.value.productId, reset)

watch(cartProducts, reset)

</script>
<style lang="scss" scoped>
.compatibility {
  margin-top: $space-s;
  margin-bottom: $space-s;
  font-size: $size-s;
  box-shadow: $shadow-s;
}

.links {
  display: flex;
  margin-top: $space-xs;
  width: 100%;
  justify-content: flex-start;
  text-transform: uppercase;
  font-family: $font-header;
  font-weight: $weight-bold;
  padding-right: $space-xs;
  color: $color-blue;
  font-size: $size-xs;

  .lnk {
    cursor: pointer;

    &:last-child {
      margin-left: $space-s
    }
  }
}
</style>
